module.exports = __webpack_public_path__ + "img/beauty_time.fcf985cc.svg";